import { c as _c } from "react/compiler-runtime";
import { ListItemMenu } from "@components/common/mobile/list-item-menu";
import { useSnapshotMenuOptions } from "@pages/project-details/project-snapshots/hooks/use-snapshot-menu-options";

/**
 * 3-dot options menu for a snapshot row, providing contextual actions such as
 * open in sphere XG and open in HoloBuilder
 */
export function SnapshotOptionsMenu(t0) {
  const $ = _c(3);
  const {
    snapshot
  } = t0;
  const menuItems = useSnapshotMenuOptions();
  let t1;
  if ($[0] !== menuItems || $[1] !== snapshot) {
    t1 = <ListItemMenu item={snapshot} menuItems={menuItems} />;
    $[0] = menuItems;
    $[1] = snapshot;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}